import styled from 'styled-components';

import mediaQueries from '@/theme/mediaQueries';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
    min-height: calc(100vh - 56px);
    padding-bottom: 48px;

    ${mediaQueries.laptop} {
        padding: 48px 0 48px 56px;
    }
`;

export const Content = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;
`;

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    border-radius: 100%;
    background-color: ${({ theme }) => theme['surface-default']};
`;
